exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rule-input[data-v-47d57f78]  .el-input__inner{border:0}\n", ""]);

// exports
